<ng-template [ngIf]="dashboardSettings">
  <button (click)="close()" class="modal-close"></button>
  <h4 class="modal-title" i18n="Title|Title Dashboard Settings Modal">
    Dashboard Settings
  </h4>
  <div class="modal-content">
    <form
      #settingsForm="ngForm"
      (ngSubmit)="saveSettings(settingsForm.valid)"
      class="form"
      novalidate
      id="dashboardForm"
    >
      <h6
        class="c-form__title"
        i18n="DashboardSettingsModal|Dashboard settings show or hide @@showHideDashboardComponents"
      >
        Show or hide dashboard components
      </h6>
      <ls-check-block-container
        [checkBlocks]="checkBlocks"
        (checkBlocksChange)="updateShowHideComponents(checkBlocks)"
      ></ls-check-block-container>

      <h6
        class="c-form__title"
        i18n="DashboardSettingsModal|Set daily targets @@setDailyTargets"
      >
        Set daily targets
      </h6>
      <div class="c-form__items">
        <div class="c-form__item u-layout-auto u-width-third">
          <label for="revenue-goal" i18n="Target|Target for revenue goal"
            >Revenue</label
          >
          <input
            type="number"
            id="revenue-goal"
            [(ngModel)]="dashboardSettings.goalTargets.revenueTarget"
            #revenueTarget="ngModel"
            name="revenue-goal"
            [min]="0"
            number=""
            required
            pattern="[\d\.]{0,11}"
            [disabled]="isTargetDisabled('revenue-goal')"
          />
          <!--TODO: HOS-10493 - this should be fixed-->
          <input type="hidden" name="Jonas-hack" ngModel="" />
          <div
            class="c-form__message u-shown"
            [hidden]="!formErrors['revenue-goal']"
            name="revenue-error"
          >
            {{ formErrors['revenue-goal'] }}
          </div>
        </div>
        <div class="c-form__item u-layout-auto u-width-third">
          <label for="receipts-goal" i18n="Target|Target for receipt goal"
            >Receipts Count</label
          >
          <input
            id="receipts-goal"
            type="number"
            [(ngModel)]="dashboardSettings.goalTargets.receiptTarget"
            #receiptTarget="ngModel"
            name="receipts-goal"
            [min]="0"
            digits=""
            required
            pattern="[\d\.]{0,11}"
            [disabled]="isTargetDisabled('receipt-goal')"
          />
          <div
            class="c-form__message u-shown"
            [hidden]="!formErrors['receipts-goal']"
            name="receipts-error"
          >
            {{ formErrors['receipts-goal'] }}
          </div>
        </div>
        <div class="c-form__item u-layout-auto u-width-third">
          <label for="customers-goal" i18n="Target|Target for customer goal"
            >Customers Count</label
          >
          <input
            id="customers-goal"
            type="number"
            [(ngModel)]="dashboardSettings.goalTargets.customerTarget"
            #customerTarget="ngModel"
            name="customers-goal"
            [min]="0"
            digits=""
            required
            pattern="[\d\.]{0,11}"
            [disabled]="isTargetDisabled('customer-goal')"
          />
          <div
            class="c-form__message u-shown"
            [hidden]="!formErrors['customers-goal']"
            name="customers-error"
          >
            {{ formErrors['customers-goal'] }}
          </div>
        </div>
      </div>

      <h6
        class="c-form__title"
        i18n="DashboardSettingsModal|Extra settings @@extraSettings"
      >
        Extra settings
      </h6>
      <div class="c-form__item u-layout-auto">
        <label for="closing-days" i18n="Label|Set restaurant closing days"
          >Set restaurant closing days</label
        >
        <ls-toggle-button
          id="closing-days"
          [items]="toggleWeekdays"
        ></ls-toggle-button>
      </div>
      <div class="c-form__item u-layout-auto u-margin-0">
        <label for="taxes-btns" i18n="Label|Show all values as"
          >Show all values as</label
        >
        <ls-toggle-button
          id="taxes-btns"
          [items]="toggleTaxes"
          [max]="1"
          [min]="1"
        ></ls-toggle-button>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      (click)="close()"
      class="o-button o-button--default"
      i18n="Button|Cancel"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="o-button o-button--success"
      form="dashboardForm"
      i18n="Button|Save"
      [disabled]="!settingsForm || !settingsForm.valid"
    >
      Save
    </button>
  </div>
</ng-template>

<div
  ls-dynamic-translation
  id="Main dashboard chart tooltip"
  i18n="Main dashboard|Tooltip main dashboard chart @@tooltipMainDashboardChart"
>
  Revenue, receipts and customer graph
</div>
<div
  ls-dynamic-translation
  id="Revenue goal tooltip"
  i18n="Target|Tooltip revenue goal @@tooltipRevenueGoal"
>
  Revenue goal component
</div>
<div
  ls-dynamic-translation
  id="Receipt goal tooltip"
  i18n="Target|Tooltip receipt goal @@tooltipReceiptGoal"
>
  Receipt goal component
</div>
<div
  ls-dynamic-translation
  id="Customer goal tooltip"
  i18n="Target|Tooltip customer goal @@tooltipCustomerGoal"
>
  Tooltip goal component
</div>
